export function getContextInitialState() {
    return {
        contextValues: {},
    };
}
